import * as React from 'react';
import { FC, useEffect, useState } from 'react';

export interface GtxAppContainerProps {
    children: React.ReactNode;
    /**
     * the component to be shown if the initFunc throw errors
     */
    error: React.ReactElement;
    /**
     * the component shown during initFunc execution
     */
    loading: React.ReactElement;
    /**
     * Usually a function to initialize the store datas
     */
    initFunc?: (setInitialData: (data: unknown) => void) => Promise<any>;
    /**
     *
     */
    setInitialData: (data: unknown) => void;
}

export const GtxAppContainer: FC<GtxAppContainerProps> = ({
    children,
    loading,
    error,
    initFunc,
    setInitialData,
}) => {
    const [isLoading, setIsLoading] = useState(initFunc ? true : false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (initFunc) {
            initFunc(setInitialData)
                .catch((error) => {
                    console.error('GtxAppContainer initFunc() catch: ', error);
                    setIsError(true);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, []);

    let renderComponent = children;

    if (isLoading) {
        renderComponent = loading;
    }

    if (isError) {
        renderComponent = error;
    }

    return <>{renderComponent}</>;
};
